import { FC } from 'react';

const FRIcon: FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="none"
    >
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9999 9.99996C19.9999 5.70031 17.2862 2.03488 13.4782 0.621948V19.378C17.2862 17.965 19.9999 14.2996 19.9999 9.99996Z"
        fill="#D80027"
      />
      <path
        d="M0.000366211 10.0006C0.000366211 14.3003 2.71416 17.9657 6.52212 19.3786V0.62262C2.71416 2.03555 0.000366211 5.70098 0.000366211 10.0006Z"
        fill="#0052B4"
      />
    </svg>
  );
};

export default FRIcon;
